module.exports = __webpack_public_path__ + "static/media/internacional-de-seguros-checkmark.94691ff0.svg";